import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./components/partner/partner.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/clear-unit`;

export default function ClearUnitRestart() {
  const { token } = useParams();
  const [rec, setRec] = useState(null);
  const [err, setErr] = useState("");
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    fetch(`${API}/${token}`).then(async (r) => (r.ok ? setRec(await r.json()) : setErr((await r.json()).detail || "Link not valid")))
      .catch(() => setErr("Could not load this link"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    const r = await fetch(`${API}/${token}/photos`, { method: "POST", body: fd });
    const j = await r.json().catch(() => ({}));
    setBusy(false);
    if (r.ok) setDone(j); else setErr(j.detail || "Upload failed");
  };

  return (
    <div className="pw-page" data-testid="clear-unit-page">
      <div className="pw-card">
        <div className="pw-brand">MOOVIN FORWARD LLC</div>
        <h1 className="pw-h2">Clear Unit verification</h1>
        {rec && <p className="pw-p" data-testid="clear-unit-address">{rec.address}</p>}
        {err && <div className="pw-err" data-testid="clear-unit-error">{err}</div>}
        {rec && rec.status !== "open" && !done && <p className="pw-p" data-testid="clear-unit-closed">This unit was already verified. The project clock has been restarted.</p>}
        {done && <p className="pw-p" data-testid="clear-unit-success">Thank you. {done.photos} photos received and vaulted. {done.restarted ? "The project clock has restarted and the crew is cleared to mobilize." : "Moovin Forward will confirm the restart shortly."}</p>}
        {rec && rec.status === "open" && !done && (
          <form onSubmit={submit} data-testid="clear-unit-form">
            <p className="pw-p">Upload at least 2 photos showing the empty appliance spaces (range, refrigerator, dishwasher, washer/dryer) and the capped gas, water and electric connections. The job restarts automatically, no call needed.</p>
            <input type="file" accept="image/*" multiple capture="environment" onChange={(e) => setFiles([...e.target.files])} data-testid="clear-unit-file-input" />
            <p className="pw-p pw-muted" data-testid="clear-unit-count">{files.length} photo(s) selected</p>
            <button className="pw-btn" disabled={busy || files.length < 2} data-testid="clear-unit-submit">{busy ? "Uploading…" : "Submit photos & restart job"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
